(function($) {
    var documentLoad = function() {
        $('.form-search-select').select2({
          placeholder: 'Select'
      }).on('change', function (e) {
          window.open(e.target.value, '_self'); // Requested to open in the same tab
      });
        $('.select2-selection__arrow').html('<img src="/wp-content/themes/delaware-county/resources/assets/sass/img/selectarrows.svg">');
    };
    $(window).on('load', documentLoad);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/shortcodes/form-search.js